import { getConfiguration } from '../config/configuration';
import { httpGet } from './httpClient';

export interface AppInsightsInstrumentationKeyResponse {
    appInsigthsInstrumentationKey: string;
  }

export class AdminApi {
  constructor() {
    const appConfig = getConfiguration();
    this.baseUrl = appConfig.adminApiBaseUrl;
  }

  private baseUrl : string;

  public getAppInsightsKey = (): Promise<AppInsightsInstrumentationKeyResponse> => httpGet<AppInsightsInstrumentationKeyResponse>(
    `${this.baseUrl}/api/GetAppInsightsInstrumentationKey`,
  );
}
